// NO DASHES IN THE REVIEW REPORT, IN ONE PASS (v1_822).
//
// The walk found model text with dashes on the review report one spot per run
// (v1_813, v1_813b, v1_813c, v1_813d each wrapped the spots that walk reached;
// the next walk found another). plainTree cleans every text node of a rendered
// element tree with plainText, at the point it is rendered: display only, never
// the data logic reads (the case state splits the source of funds score on a
// dash). Form fields keep what the officer types (a textarea's value is a prop,
// not a text node), and an element marked data-verbatim is left as it is.
// Components rendered inside the tree render their own output, so those keep
// their own plainText calls.
import React from 'react';
import { plainText } from './plain-text.js';

const SKIP = new Set(['textarea', 'style', 'script', 'code']);

export function plainTree(node) {
  // A text node that is only a dash (a "none" placeholder in the data) reads
  // "Not stated", never an empty cell.
  if (typeof node === 'string') return /^\s*[–—-]\s*$/.test(node) ? 'Not stated' : plainText(node);
  if (Array.isArray(node)) return node.map(plainTree);
  if (!React.isValidElement(node)) return node;
  const props = node.props || {};
  if (typeof node.type === 'string' && SKIP.has(node.type)) return node;
  if (props['data-verbatim']) return node;
  if (props.children === undefined) return node;
  // Children given as a list (JSX siblings) go back as a list, so React sees
  // the same static children and asks for no keys; a mapped array inside keeps
  // its own keys.
  if (Array.isArray(props.children)) return React.cloneElement(node, undefined, ...props.children.map(plainTree));
  const next = plainTree(props.children);
  return next === props.children ? node : React.cloneElement(node, undefined, next);
}
